<ng-container *ngIf="viewModel$ | async as vm">
  <div class="row no-gutters">
    <div class="col p-1">
      <ul class="list-group">
        <li *ngIf="!vm.campaigns || vm.campaigns.length === 0" class="
            list-group-item list-group-item-action
            d-flex
            justify-content-start
            align-items-center
            p-1
          ">
          <small class="d-inline-block text-truncate">
            No campaigns scheduled
          </small>
        </li>
        <li *ngFor="let c of vm.campaigns | orderBy: 'name'" class="
            list-group-item list-group-item-action
            d-flex
            justify-content-start
            align-items-left
            p-1
            text-nowrap
          " [ngClass]="{ active: c.campaignId === vm.campaignId }" (click)="select(c.campaignId)">
          <span class="badge badge-primary badge-pill" role="button" (click)="
              c.campaignType === 'UAT'
                ? launchuat($event, c.campaignId, c.dialType, c.actionType)
                : c.actionType.startsWith('IB')
                ? launchib($event, c.campaignId, c.dialType)
                : launch($event, c.campaignId, c.dialType)
            " (disabled)="(vm.campaignId === c.campaignId)"><i class="fas fa-rocket"></i></span>
          <small class="d-inline-block ml-2 campaign-item text-truncate" [title]="c.name">{{ c.campaignId }} - {{ c.name
            }}</small>
        </li>
        <li *libHasClaim="Unity4Claim.OmniChannel" class="
            list-group-item list-group-item-action
            d-flex
            justify-content-start
            align-items-center
            p-1
          " [ngClass]="{ active: vm.omniChannel }">
          <span class="badge badge-primary badge-pill" role="button" (click)="omniChannel()"><i
              class="fas fa-rocket"></i></span>
          <small class="d-inline-block text-truncate ml-2">OmniChannel</small>
        </li>
      </ul>
    </div>
  </div>
</ng-container>